import { I18nConfig } from '@lib/interfaces';

/**
 * i18n（国際化対応）構成
 */
export const I18N_CONFIG: I18nConfig = {
  // サポート可能な言語定義
  supportedLocales: {
    ja: 'ja', // 日本語
    en: 'en', // 英語
  },
  // デフォルト言語
  defaultLanguage: 'ja',
  // ロードするファイルのリスト
  loadFileList: [
    {
      prefix: 'm_static_message/',
    },
    {
      prefix: 'm_error_message/',
    },
    {
      prefix: 'm_dynamic_message/',
    },
    {
      prefix: 'm_list_data/',
    },
    // [start] servicingアプリ用
    {
      prefix: 'm_airline_i18n/',
    },
    // 提携: 使用しないためコメントアウトして読み込まれないようにする
    // {
    //   prefix: 'm_tax_i18n/',
    // },
    {
      prefix: 'm_airport_i18n/',
    },
    {
      prefix: 'm_country_i18n/',
    },
  ],
};
